import axios from "axios";
import { ERROR_OCCURED, INVALID_TOKEN_CODE, SERVER_ERROR, SUCCESS_CODE, SESSION_EXPIRED, SEARCH_LIMIT, TIMEOUT_ERROR, SERVICE_UNAVAILABLE, } from "../../constants/return_code_constants";
import { SEND_ALERT } from "../global/types";
import { GENERAL_SET_GRAPH_DATA, GENERAL_SET_PIE_DATA, } from "../portfolio/types";
import { GENERAL_USER_REDUCER } from "../user/types";
export const ASSET_SCREEN = "assets";
export const ASSET_CAT_API = "assets_cat";
export const INCOMEXP_SCREEN = "incomexp";
export const INCOME_API = "income";
export const EXP_API = "expense";
export const CASH_API = "cashflow";
export const LIAB_SCREEN = "liability";
export const CREDIT_API = "credit";
export const NET_SCREEN = "networth";
export const NET_API = "networth";
export const getScreenFromApi = (api) => {
    switch (api) {
        case ASSET_CAT_API:
            return ASSET_SCREEN;
        case INCOME_API:
            return INCOMEXP_SCREEN;
        case EXP_API:
            return INCOMEXP_SCREEN;
        case CASH_API:
            return INCOMEXP_SCREEN;
        case CREDIT_API:
            return LIAB_SCREEN;
        case NET_API:
            return NET_SCREEN;
    }
};
export const base_domain = process.env.REACT_APP_API_BASE_URL;
// Create a singleton axios instance with interceptors
const axiosInstance = axios.create({
    baseURL: base_domain,
    headers: { "Content-Type": "application/json" },
    timeout: 60000,
    withCredentials: true,
});
axiosInstance.interceptors.response.use((response) => response, async (error) => {
    const status = error?.response?.status;
    if (status === 401) {
        // Web-only fast path: clear persisted token and force login
        if (typeof globalThis !== "undefined" && globalThis.window) {
            try {
                globalThis.window.localStorage.clear();
            }
            catch (_) { }
            try {
                const doc = globalThis.document;
                if (doc) {
                    const clearAllCookies = () => {
                        const cookies = doc.cookie.split("; ");
                        for (let i = 0; i < cookies.length; i++) {
                            const cookie = cookies[i];
                            const eqPos = cookie.indexOf("=");
                            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                            const domains = ['', 'app.plootus.com', '.plootus.com', 'www.plootus.com'];
                            const paths = ['/', ''];
                            domains.forEach(domain => {
                                paths.forEach(path => {
                                    let cookieStr = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
                                    if (path)
                                        cookieStr += ` path=${path};`;
                                    if (domain)
                                        cookieStr += ` domain=${domain};`;
                                    doc.cookie = cookieStr;
                                });
                            });
                        }
                    };
                    clearAllCookies();
                }
                globalThis.window.location.replace("https://plootus.com");
            }
            catch (_) { }
        }
    }
    return Promise.reject(error);
});
// Wrapper that uses the shared instance
export const apiClient = async (config) => axiosInstance.request(config);
export const axios_config = (api, paramsOrData, method) => ({
    method,
    url: api, // 🆕 CHANGED: apiClient already has baseURL, so no need to prepend base_domain
    [method === "post" ? "data" : "params"]: paramsOrData,
});
// Reusable functions
export const async_func_data = async (apiUrl, paramsOrData, [getState], method, isTokenRequired = true) => {
    try {
        const axiosConfig = axios_config(apiUrl, paramsOrData, method);
        // console.log("Code entered the try block ")
        if (isTokenRequired) {
            const token = getState().userReducer.token;
            if (token)
                axiosConfig.headers = {
                    ...axiosConfig.headers,
                    Authorization: token,
                };
        }
        // 🆕 CHANGED HERE — use .request() instead of calling instance as function
        const response = await apiClient(axiosConfig);
        return { responseData: response.data, errorCode: SUCCESS_CODE };
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            // Handle timeout errors specifically
            if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                console.error(`Request timeout on ${apiUrl}:`, error.message);
                return {
                    responseData: {
                        message: 'Request timeout. Please check your internet connection and try again.',
                        timeout: true
                    },
                    errorCode: TIMEOUT_ERROR // HTTP 408 Request Timeout
                };
            }
            // Handle network errors
            if (error.code === 'ERR_NETWORK' || !error.response) {
                console.error(`Network error on ${apiUrl}:`, error.message);
                return {
                    responseData: {
                        message: 'Network error. Please check your internet connection.',
                        networkError: true
                    },
                    errorCode: SERVICE_UNAVAILABLE // HTTP 503 Service Unavailable
                };
            }
            const status = error.response?.status ?? 500;
            const data = error.response?.data;
            console.error(`Axios error on ${apiUrl}:`, data || error.message);
            return { responseData: data, errorCode: data?.errCode || status };
        }
        console.error("Unhandled error:", error);
        console.log("Code entered the err block ");
        return { responseData: null, errorCode: 500 };
    }
};
// Handle Response Codes
export const handleResponse = async (errorCode, dispatch, action) => {
    switch (errorCode) {
        case SUCCESS_CODE:
            if (action) {
                dispatch(action);
            }
            return SUCCESS_CODE;
        case INVALID_TOKEN_CODE: {
            dispatch({
                type: GENERAL_USER_REDUCER,
                payload: { token: null, session_expired: true },
            });
            return ERROR_OCCURED;
        }
        case SERVER_ERROR: {
            dispatch({
                type: SEND_ALERT,
                payload: {
                    title: "Error",
                    textContent: "Sorry Some Error Occured.",
                },
            });
            return ERROR_OCCURED;
        }
        case SEARCH_LIMIT: {
            dispatch({
                type: SEND_ALERT,
                payload: {
                    title: "Alert",
                    textContent: "Search limit exceed.",
                },
            });
            return ERROR_OCCURED;
        }
        case SESSION_EXPIRED: {
            dispatch({
                type: GENERAL_USER_REDUCER,
                payload: { token: null, session_expired: true },
            });
            return ERROR_OCCURED;
        }
        default:
            return errorCode;
    }
};
const paramsToObjects = (params) => {
    const paramOb = {};
    params.map((param, index) => {
        paramOb[`param${index + 1}`] = param;
    });
    return paramOb;
};
const getNewAccordObject = (params1, params2, params3, params4, container, visualCont, metaData) => ({
    level1: paramsToObjects(params1),
    level2: paramsToObjects(params2),
    level3: paramsToObjects(params3),
    level4: paramsToObjects(params4),
    container,
    visualCont,
    metaData,
});
export const screen_api_to_params_mapping = (api) => {
    switch (api) {
        case ASSET_CAT_API:
            return getNewAccordObject(["totalI", "container", "isAsset", "list3"], // level1
            ["totalP", "providerName", "list2"], // level2
            ["balance", "accountName", "accountNumber", undefined, "list1"], // level3
            ["value", "symbol", "description", "costBasis", "lastUpdated"], // level 4
            undefined, // container
            undefined // visualCont
            );
        case CREDIT_API:
            return getNewAccordObject(["totalI", "container", "isAsset", "list3"], // level1
            ["totalP", "providerName", "list2"], // level2
            ["balance", "accountName", "lastUpdated", "accountNumber", "list1"], // level3
            [
                "amount",
                "category",
                "description",
                "categoryType",
                "transactionDate",
            ], // level 4
            undefined, // container
            undefined // visualCont
            );
        case NET_API:
            return getNewAccordObject(["totalI", "conatiner", "isAsset", "list3"], // level1
            ["totalP", "providerName", "list2"], // level2
            ["balance", "accountName", undefined, "accountNumber", "list1"], // level3
            [
                // // level4
                "amount", // 1
                "category", // 2
                "description", // 3
                "categoryType", // 4
                "transactionDate", // 5
                "value", // 6
                "costBasis", // 7
                "description", // 8
                "lastUpdated", // 9
            ], "networth_data.0.data", // container
            "networth" // visualCont
            );
        case INCOME_API:
            return getNewAccordObject(["totalC", "category", "categoryType", "container", "list"], // level1
            ["amount", "description", "categoryType", "transactionDate"], // level2
            [], [], "transaction", // container
            undefined, // visualCont
            {
                sortParams: [
                    "amount",
                    "amount",
                    "transactionDate",
                    "transactionDate",
                ],
                searchParam: "description",
                transactionParams: paramsToObjects([
                    "amount",
                    "description",
                    "categoryType",
                    "category",
                    "transactionDate",
                ]),
            });
        case EXP_API:
            return getNewAccordObject(["totalC", "category", "categoryType", "container", "list"], // level1
            ["amount", "description", "categoryType", "transactionDate"], // level2
            [], [], "transaction", // container
            undefined, // visualCont
            {
                sortParams: [
                    "amount",
                    "amount",
                    "transactionDate",
                    "transactionDate",
                ],
                searchParam: "description",
                transactionParams: paramsToObjects([
                    "amount",
                    "description",
                    "categoryType",
                    "category",
                    "transactionDate",
                ]),
            });
        case CASH_API:
            return getNewAccordObject([
                "totalMonthwise",
                "currentMonth",
                "currentYear",
                undefined,
                "transactionData",
            ], // level1
            ["amount", "description", "categoryType", "transactionDate"], // level2
            [], [], "transaction", // container
            undefined, // visualCont
            {
                searchParam: "description",
                searchCont: "transactionData",
            });
        default:
            return undefined;
    }
};
const get_api_params_object = (url, otherParams) => ({
    url,
    otherParams,
});
const get_api_object_details = (params, successActionType, pie_args, responseContainer, transactionApiParams, payloadCont) => ({
    api_params: get_api_params_object(...params),
    successActionType,
    pie_args,
    responseContainer,
    transactionApiParams: transactionApiParams
        ? get_api_params_object(...transactionApiParams)
        : undefined,
    payloadCont,
});
export const get_api_responseContainer = (api) => {
    switch (api) {
        case ASSET_CAT_API:
            return get_api_object_details(["holding/getAssets"], GENERAL_SET_PIE_DATA, ["totalI", "container"], undefined);
        case CREDIT_API:
            return get_api_object_details(["account/getLiabilities"], GENERAL_SET_PIE_DATA, ["totalI", "container"], undefined);
        case NET_API:
            return get_api_object_details(["networth/getNetworthNested?interval=Y"], GENERAL_SET_GRAPH_DATA, [
                "networth",
                "networth",
                "networth_data.0.data",
                "networth_data.0.netTotal",
            ], undefined, undefined, "networth");
        case INCOME_API:
            return get_api_object_details(["transaction/getTransactions?category=INCOME"], GENERAL_SET_PIE_DATA, ["totalC", "category"], "transaction", [
                "transaction/getTransactionsByDate?category=INCOME",
                { container: "transaction.0.transactiondata" },
            ]);
        case EXP_API:
            return get_api_object_details(["transaction/getTransactions?category=EXPENSE"], GENERAL_SET_PIE_DATA, ["totalC", "category"], "transaction", [
                "transaction/getTransactionsByDate?category=EXPENSE",
                { container: "transaction.0.transactiondata" },
            ]);
        case CASH_API:
            return get_api_object_details(["transaction/getTransactionsByDate?category=ALL"], GENERAL_SET_GRAPH_DATA, ["amount", "0.data", "0.data", "0.totalCashFlow", "currentMonth"], "transaction");
        default:
            return get_api_object_details(["holding/getAssets"], GENERAL_SET_PIE_DATA, ["totalI", "container"], undefined);
    }
};
export const feesSavedStratMapping = (strategy) => {
    switch (strategy) {
        case 0:
            return "superconservative";
        case 1:
            return "conservative";
        case 2:
            return "moderate";
        case 3:
            return "growth";
        case 4:
            return "supergrowth";
        default:
            return "superconservative";
    }
};
